import { NodeContext } from "../../../../poly/NodeContext";
import {
  GlConnectionPointType,
  GlConnectionPoint,
  GLParamTypeToConnectionPointTypeMap
} from "./Gl";
import {
  JsConnectionPointType,
  JsConnectionPoint,
  JsParamTypeToConnectionPointTypeMap
} from "./Js";
import { EventConnectionPoint, EventConnectionPointType } from "./Event";
import {
  ActorConnectionPoint,
  ActorConnectionPointType,
  ActorParamTypeToConnectionPointTypeMap
} from "./Actor";
export const DEFAULT_CONNECTION_POINT_ENUM_MAP = {
  [NodeContext.ACTOR]: ActorConnectionPointType.TRIGGER,
  [NodeContext.ANIM]: void 0,
  [NodeContext.AUDIO]: void 0,
  [NodeContext.COP]: void 0,
  [NodeContext.EVENT]: EventConnectionPointType.BASE,
  [NodeContext.GL]: GlConnectionPointType.FLOAT,
  [NodeContext.JS]: JsConnectionPointType.FLOAT,
  [NodeContext.MANAGER]: void 0,
  [NodeContext.MAT]: void 0,
  [NodeContext.OBJ]: void 0,
  [NodeContext.POST]: void 0,
  [NodeContext.ROP]: void 0,
  [NodeContext.SOP]: void 0
};
export function create_connection_point(context, name, type) {
  switch (context) {
    case NodeContext.ACTOR: {
      return new ActorConnectionPoint(name, type);
    }
    case NodeContext.EVENT: {
      return new EventConnectionPoint(name, type);
    }
    case NodeContext.GL: {
      return new GlConnectionPoint(name, type);
    }
    case NodeContext.JS: {
      return new JsConnectionPoint(name, type);
    }
    default: {
      return void 0;
    }
  }
}
export function param_type_to_connection_point_type_map(context) {
  switch (context) {
    case NodeContext.ACTOR: {
      return ActorParamTypeToConnectionPointTypeMap;
    }
    case NodeContext.EVENT: {
      return void 0;
    }
    case NodeContext.GL: {
      return GLParamTypeToConnectionPointTypeMap;
    }
    case NodeContext.JS: {
      return JsParamTypeToConnectionPointTypeMap;
    }
    default: {
      return void 0;
    }
  }
}
